import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const Nav = () => {
  const history = useHistory()

  const onClick = (path) => history.push(`/parents/${path}`)

  return (
    <ul className="flex items-center flex-1 px-6 text-xl font-light">
      <NavItem label="Kids" onClick={() => onClick('kids')} />
      <NavItem label="Chores" onClick={() => onClick('chores')} />
      <NavItem label="Rewards" onClick={() => onClick('rewards')} />
      <NavItem label="Settings" onClick={() => onClick('settings')} />
      <NavItemLogout label="Exit" onClick={() => history.push('/kids')} />
    </ul>
  )
}

const NavItemLogout = ({ label, onClick }) => (
  <li
    className="cursor-pointer text-gray-500 hover:text-pink-500"
    onClick={onClick}
  >
    {label}
  </li>
)

const NavItem = ({ label, onClick }) => {
  const { pathname } = useLocation()
  const isActive = pathname.includes(label.toLowerCase())

  return (
    <li
      onClick={onClick}
      className={`py-4 px-2 mr-6 cursor-pointer hover:text-pink-500 ${
        isActive ? 'text-pink-500' : 'text-gray-500'
      }`}
    >
      {label}
    </li>
  )
}

export default Nav
